<template>
    <el-form ref="form" label-width="120px" label-position="top" v-loading="$parentInfo.Dialog_ClassInformation.loading">
        <el-form-item label="老师课程回访">
            <el-row>
                <el-col :span="24">
                    <el-table
                            :data="order_class_teacherVisits"
                            style="width: 100%"
                            :height="150"
                            border
                            size="mini">
                        <el-table-column prop="id" label="序号" min-width="7%"></el-table-column>
                        <el-table-column prop="created_at"  label="回访时间" min-width="10%"></el-table-column>
                        <el-table-column prop="classPlan_date" label="课程日期" min-width="10%"></el-table-column>
                        <el-table-column prop="content"  label="内容" min-width="73%"></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-form-item>
        <div class="m-separator m-separator--space m-separator--dashed"></div>
        <el-form-item label="教师互动">
            <el-row>
                <el-col :span="24">
                    <el-table
                            :data="order_class_interactives"
                            style="width: 100%"
                            :height="150"
                            border
                            size="mini">
                        <el-table-column prop="id" label="序号" min-width="7%"></el-table-column>
                        <el-table-column prop="created_at"  label="编辑时间" min-width="10%"></el-table-column>
                        <el-table-column prop="sending_date" label="发送时间" min-width="10%"></el-table-column>
                        <el-table-column prop="students"  label="对象" min-width="15%"></el-table-column>
                        <el-table-column prop="content"  label="内容" min-width="51%"></el-table-column>
                        <el-table-column  label="操作" min-width="7%">
                            <template slot-scope="scope">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.isSending">
                                        <el-popover
                                                placement="left-start"
                                                width="200"
                                                trigger="hover"
                                        >
                                            <div>
                                                <div>已读:</div>
                                                <div v-for="student in scope.row.students">
                                                    <div v-if="student.is_read=='true'">
                                                        {{student.name}}
                                                    </div>
                                                </div>
                                                <div class="m-separator m-separator--space m-separator--dashed"></div>
                                                <div>未读:</div>
                                                <div v-for="student in scope.row.students" >
                                                    <div v-if="student.is_read=='false'">
                                                        {{student.name}}
                                                    </div>
                                                </div>
                                            </div>
                                            <el-button slot="reference">已发送</el-button>
                                        </el-popover>
                                    </div>
                                    <div v-else>
                                        <el-button size="small" @click="">未发送</el-button>
                                    </div>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-form-item>
        <div class="m-separator m-separator--space m-separator--dashed"></div>
        <el-form-item label="课程通知">
            <el-row>
                <el-col :span="24">
                    <el-table
                            :data="order_class_notices"
                            style="width: 100%"
                            :height="150"
                            border
                            size="mini">
                        <el-table-column prop="id" label="序号" min-width="7%"></el-table-column>
                        <el-table-column prop="created_at"  label="编辑时间" min-width="10%"></el-table-column>
                        <el-table-column prop="sending_date" label="发送时间" min-width="10%"></el-table-column>
                        <el-table-column prop="content"  label="内容" min-width="66%"></el-table-column>
                        <el-table-column  label="操作" min-width="7%">
                            <template slot-scope="scope">
                                <div v-if="scope.row.isSending">
                                    <el-popover
                                            placement="left-start"
                                            width="200"
                                            trigger="hover"
                                    >
                                        <div>
                                            <div>已读:</div>
                                            <div v-for="student in scope.row.students">
                                                <div v-if="student.is_read=='true'">
                                                    {{student.name}}
                                                </div>
                                            </div>
                                            <div class="m-separator m-separator--space m-separator--dashed"></div>
                                            <div>未读:</div>
                                            <div v-for="student in scope.row.students">
                                                <div v-if="student.is_read=='false'">
                                                    {{student.name}}
                                                </div>
                                            </div>
                                        </div>
                                        <el-button slot="reference">已发送</el-button>
                                    </el-popover>
                                </div>
                                <div v-else>
                                    <el-button slot="reference" size="small" @click="">未发送</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-form-item>
        <div class="m-separator m-separator--space m-separator--dashed"></div>
        <el-form-item label="学生反馈">
            <el-row>
                <el-col :span="24">
                    <el-table
                            :data="order_class_assessments"
                            style="width: 100%"
                            :height="150"
                            border
                            size="mini">
                        <el-table-column prop="id" label="序号" min-width="7%"></el-table-column>
                        <el-table-column prop="student_name"  label="学生" min-width="10%"></el-table-column>
                        <el-table-column prop="created_at" label="评价时间" min-width="10%"></el-table-column>
                        <el-table-column   label="评价" min-width="15%">
                            <template slot-scope="scope">
                                <el-rate v-model="scope.row.teacherRate" disabled></el-rate>
                            </template>
                        </el-table-column>
                        <el-table-column prop="content"  label="内容" min-width="58%"></el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        name: "Dialog_ClassInformation",
        data() {
            return {

            }
        },
        computed: {
            order_class_teacherVisits: function () {
                return this._.orderBy(this.$parentInfo.Dialog_ClassInformation.class_teacherVisits, 'id', 'asc');
            },
            order_class_interactives: function () {
                return this._.orderBy(this.$parentInfo.Dialog_ClassInformation.class_interactives, 'id', 'asc');
            },
            order_class_notices: function () {
                return this._.orderBy(this.$parentInfo.Dialog_ClassInformation.class_notices, 'id', 'asc');
            },
            order_class_assessments: function () {
                return this._.orderBy(this.$parentInfo.Dialog_ClassInformation.class_assessments, 'id', 'asc');
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleInfo();
        },
        methods: {
            handleInfo(){
                this.$wApi.send(this.$parentInfo.path, 'get_classInformation', {
                    'class_id': this.$parentInfo.Dialog_ClassInformation.class_id
                });
            },
        }
    }
</script>

<style scoped>

</style>